import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-start',
  templateUrl: './button-start.component.html',
  styleUrls: ['./button-start.component.less']
})
export class ButtonStartComponent implements OnInit {
  @Input() disabled = false;
  @Input() subTitle = '';
  constructor() { }

  ngOnInit(): void {
  }

}
